module.exports = __webpack_public_path__ + "img/24.10.pH.b5cbe75e.png";